export type IValidateRegEx = (s: string, type?: 'number') => RegExpMatchArray | null;

export function validateRegEx(s: string, type?: 'number'): RegExpMatchArray | null {
  const num = /^[0-9]*\.?[0-9]*$/;
  let rgx;
  if (type === 'number') {
    rgx = num;
  }
  return rgx ? s.match(rgx) : null;
}
